import { HTTPError } from 'ky';
import { ApiError } from 'types/api/api-error';

export default class OneBadRequest extends Error {
  private error: ApiError;

  constructor(error: ApiError, cause?: HTTPError) {
    super(error.errorMessage, { cause });
    this.error = error;
    Object.setPrototypeOf(this, OneBadRequest.prototype);
  }

  getError() {
    return this.error;
  }

  getMessage() {
    return this.error.errorMessage;
  }

  getCode() {
    return this.error.errorCode;
  }

  getErrors() {
    return this.error.errors;
  }

  getCause() {
    return this.cause as HTTPError;
  }
}
